// extracted by css-extract-rspack-plugin
export default {"menuItem":"GwGo9","menuItemWithBorder":"tO_rb","menuItemStack":"w6yy0"};